import { useTranslation } from "react-i18next";
import { TableHeaderProps } from "../types";

export const useTableHeaders = (): TableHeaderProps[] => {
    const { t } = useTranslation();

    return [
        {
            id: 'preview',
            label: '',
        },
        {
            id: 'linkInBioName',
            label: t('name'),
        },
        {
            id: 'link',
            label: t('link'),
        },
        {
            id: 'view',
            label: '',
        },
    ];
};
